import React from 'react';
import ReactDOM from 'react-dom';
import './styles/index.scss';
import Main from "./components/Main";

ReactDOM.render(
  <React.StrictMode>
    <Main />
  </React.StrictMode>,
  document.getElementById('root')
);
